/*!
 * Proton "Add your FREE hat" cart popup — 2026-07-29
 *
 * Goal (Diego): when a shopper adds an eligible paddle to their cart, pop a
 * modal offering a FREE rope cap. The shopper picks one of four looks
 * (two logos x two colorways); we add that hat variant to the cart. The live
 * Shopify automatic BxGy discount ("Free Rope Cap with any single paddle",
 * DiscountAutomaticNode/1693597139236) then zeroes the hat at checkout.
 *
 * BEHAVIOR / ANTI-NAG (mirrors the bottle+towel build so it never feels spammy):
 *   - Offered at most once per cart. Once shown, we set an "offered" flag and
 *     do not re-pop for the same cart.
 *   - If the shopper closes with "No thanks", we set a "dismissed" flag and
 *     never re-offer until the cart is emptied of paddles.
 *   - If the shopper removes the free hat manually, we honor it (no re-add).
 *   - Flags reset on a fresh cart (all eligible paddles removed).
 *
 * ELIGIBILITY: gated to the exact products in the Shopify collection the
 *   discount is scoped to ("Paddles - Free Ride Eligible"), fetched live with a
 *   hardcoded fallback, so we never offer a free hat on a paddle the discount
 *   won't cover.
 *
 * The hat line carries hidden line-item property _proton_gift:"1" so cleanup
 * only ever touches a hat WE added.
 *
 * Kill switch: window.ProtonHat.disable()  (or set PROTON_HAT_ENABLED=false)
 * Deploy: node ~/proton/scripts/_deploy-paddle-hat-popup.js
 */
(function () {
  "use strict";

  var GIFT_PROP = "_proton_gift";
  var ELIGIBLE_HANDLE = "paddles-free-ride-eligible";

  // Fallback paddle product ids (same "Free Ride Eligible" set as bottle+towel).
  var FALLBACK_ELIGIBLE = [
    9981331570980, 10266938507556, 9652071891236, 10237271834916,
    10266949976356, 10266943684900, 10237350183204, 10266994180388,
    10237358997796, 10384218358052, 10384216293668
  ];

  // The four free hats (variant id + label + image).
  var HATS = [
    { id: 55812195123492, style: "Atom Logo",   color: "Black / White", img: "https://cdn.shopify.com/s/files/1/0717/0372/4324/files/classic-rope-cap-black-white-front-6a637963a8403.jpg?v=1784904052" },
    { id: 55812195156260, style: "Atom Logo",   color: "White / Black", img: "https://cdn.shopify.com/s/files/1/0717/0372/4324/files/classic-rope-cap-white-black-front-6a637963a8f66.jpg?v=1784904052" },
    { id: 55929048400164, style: "Proton Logo", color: "Black / White", img: "https://cdn.shopify.com/s/files/1/0717/0372/4324/files/classic-rope-cap-black-white-front-6a6a42cd8e2bb.jpg?v=1785348836" },
    { id: 55929048432932, style: "Proton Logo", color: "White / Black", img: "https://cdn.shopify.com/s/files/1/0717/0372/4324/files/classic-rope-cap-white-black-front-6a6a42cd8ec46.jpg?v=1785348835" }
  ];
  var HAT_IDS = HATS.map(function (h) { return h.id; });

  var LS_OFFERED   = "proton_hat_offered";
  var LS_DISMISSED = "proton_hat_dismissed";
  var LS_ADDED     = "proton_hat_added";

  var STATE = { busy: false, eligible: null, timer: null, open: false, sel: HATS[0].id };

  function log() { try { console.info.apply(console, ["[paddle-hat]"].concat([].slice.call(arguments))); } catch (e) {} }
  function lsGet(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }
  function lsSet(k, v) { try { localStorage.setItem(k, v); } catch (e) {} }

  function inactiveContext() {
    try {
      if (window.ProtonHat && window.ProtonHat._disabled) return true;
      if (window.PROTON_HAT_ENABLED === false) return true;
      if (window.Shopify && window.Shopify.designMode) return true;
      var p = location.pathname || "";
      if (p.indexOf("/checkout") === 0 || p.indexOf("/checkouts") === 0) return true;
    } catch (e) {}
    return false;
  }

  function fetchJSON(url, opts) {
    return fetch(url, Object.assign({ credentials: "same-origin", headers: { Accept: "application/json" } }, opts || {}))
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; });
  }

  function loadEligible() {
    if (STATE.eligible) return Promise.resolve(STATE.eligible);
    return fetchJSON("/collections/" + ELIGIBLE_HANDLE + "/products.json?limit=250")
      .then(function (j) {
        var ids = (j && Array.isArray(j.products)) ? j.products.map(function (p) { return Number(p.id); }).filter(Boolean) : [];
        STATE.eligible = ids.length ? ids : FALLBACK_ELIGIBLE.slice();
        return STATE.eligible;
      })
      .catch(function () { STATE.eligible = FALLBACK_ELIGIBLE.slice(); return STATE.eligible; });
  }

  function getCart() { return fetchJSON("/cart.js"); }

  function paddleUnits(cart, eligible) {
    if (!cart || !Array.isArray(cart.items)) return 0;
    return cart.items.reduce(function (n, it) {
      return eligible.indexOf(Number(it.product_id)) !== -1 ? n + (it.quantity || 0) : n;
    }, 0);
  }
  function hatInCart(cart) {
    if (!cart || !Array.isArray(cart.items)) return false;
    return cart.items.some(function (it) { return HAT_IDS.indexOf(Number(it.variant_id)) !== -1; });
  }
  function ourHatLines(cart) {
    if (!cart || !Array.isArray(cart.items)) return [];
    return cart.items.filter(function (it) {
      if (HAT_IDS.indexOf(Number(it.variant_id)) === -1) return false;
      var props = it.properties || {};
      return props && String(props[GIFT_PROP]) === "1";
    });
  }

  function addHat(variantId) {
    var body = { items: [{ id: variantId, quantity: 1, properties: {} }] };
    body.items[0].properties[GIFT_PROP] = "1";
    return fetch("/cart/add.js", {
      method: "POST", credentials: "same-origin",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify(body)
    }).then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
  }
  function removeLine(lineKey) {
    return fetch("/cart/change.js", {
      method: "POST", credentials: "same-origin",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ id: lineKey, quantity: 0 })
    }).then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
  }
  function notifyThemeCartChanged() {
    try {
      document.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true }));
      document.dispatchEvent(new CustomEvent("cart:updated", { bubbles: true }));
      if (window.PubSub && window.PubSub.publish) window.PubSub.publish("cart-update");
    } catch (e) {}
  }

  /* ---------------- modal UI ---------------- */
  var STYLE_ID = "proton-hat-style";
  function injectStyle() {
    if (document.getElementById(STYLE_ID)) return;
    var s = document.createElement("style");
    s.id = STYLE_ID;
    s.textContent =
    ".ph-ov,.ph-ov *{box-sizing:border-box}"+
    ".ph-ov{position:fixed;inset:0;z-index:2147483000;display:flex;align-items:flex-end;justify-content:center;background:rgba(9,20,40,.55);-webkit-backdrop-filter:blur(6px);backdrop-filter:blur(6px);opacity:0;transition:opacity .22s;font-family:-apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,sans-serif}"+
    ".ph-ov.ph-in{opacity:1}"+
    "@media(min-width:640px){.ph-ov{align-items:center}}"+
    ".ph-card{width:100%;max-width:520px;max-height:92vh;overflow:auto;background:linear-gradient(180deg,#eaf3ff 0%,#f7fbff 34%,#ffffff 72%);border-radius:22px 22px 0 0;border:1px solid rgba(21,133,199,.18);box-shadow:0 -18px 60px rgba(11,31,58,.34);padding:20px 18px 22px;transform:translateY(24px);transition:transform .26s;color:#0b1f3a}"+
    "@media(min-width:640px){.ph-card{border-radius:24px}}"+
    ".ph-ov.ph-in .ph-card{transform:translateY(0)}"+
    ".ph-x{position:absolute;top:12px;right:14px;width:34px;height:34px;border:none;border-radius:50%;background:rgba(255,255,255,.7);color:#5b6a82;font-size:20px;font-weight:700;cursor:pointer;box-shadow:0 4px 12px rgba(11,31,58,.12)}"+
    ".ph-badge{display:inline-block;background:linear-gradient(135deg,#12a86b,#0b7a53);color:#fff;font-size:11px;font-weight:800;letter-spacing:.08em;text-transform:uppercase;padding:6px 13px;border-radius:999px;box-shadow:0 8px 20px rgba(11,122,83,.32)}"+
    ".ph-h{font-size:22px;line-height:1.12;font-weight:900;letter-spacing:-.015em;margin:11px 0 4px}"+
    ".ph-h b{color:#1585c7}"+
    ".ph-sub{font-size:13.5px;color:#5b6a82;font-weight:600;margin:0 0 15px}"+
    ".ph-grid{display:grid;grid-template-columns:repeat(2,1fr);gap:11px}"+
    "@media(min-width:640px){.ph-grid{grid-template-columns:repeat(4,1fr)}}"+
    ".ph-tile{position:relative;cursor:pointer;background:rgba(255,255,255,.78);border:2px solid rgba(21,133,199,.16);border-radius:16px;padding:9px 9px 11px;text-align:center;transition:transform .14s,border-color .14s,box-shadow .14s}"+
    ".ph-tile:hover{transform:translateY(-2px);box-shadow:0 12px 26px rgba(21,133,199,.18)}"+
    ".ph-tile.ph-on{border-color:#12a86b;box-shadow:0 12px 26px rgba(18,168,107,.24)}"+
    ".ph-imw{border-radius:11px;overflow:hidden;background:linear-gradient(165deg,#f2f8ff,#fff)}"+
    ".ph-imw img{width:100%;aspect-ratio:1;object-fit:contain;display:block}"+
    ".ph-free{position:absolute;left:7px;top:7px;background:linear-gradient(135deg,#12a86b,#0b7a53);color:#fff;font-size:9px;font-weight:800;letter-spacing:.03em;padding:2.5px 7px;border-radius:999px}"+
    ".ph-ck{position:absolute;top:7px;right:7px;width:22px;height:22px;border-radius:50%;background:#12a86b;color:#fff;font-size:13px;font-weight:900;display:none;align-items:center;justify-content:center}"+
    ".ph-tile.ph-on .ph-ck{display:flex}"+
    ".ph-st{font-weight:900;font-size:12.5px;margin-top:8px;line-height:1.15}"+
    ".ph-cl{font-size:11.5px;font-weight:700;color:#5b6a82;margin-top:2px}"+
    ".ph-cta{margin-top:16px;width:100%;padding:15px;border:none;border-radius:14px;background:linear-gradient(135deg,#1585c7,#0b57a3);color:#fff;font-weight:800;font-size:15.5px;cursor:pointer;box-shadow:0 12px 26px rgba(21,133,199,.4);letter-spacing:.01em;transition:filter .15s,transform .1s}"+
    ".ph-cta:hover{filter:brightness(1.08)}.ph-cta:active{transform:scale(.99)}"+
    ".ph-cta[disabled]{opacity:.7;cursor:default}"+
    ".ph-no{display:block;margin:11px auto 0;background:none;border:none;color:#8a94a6;font-size:12.5px;font-weight:700;cursor:pointer;text-decoration:underline}"+
    ".ph-note{text-align:center;font-size:11.5px;color:#9aa3b2;font-weight:600;margin:9px 0 0}";
    document.head.appendChild(s);
  }

  function closeModal() {
    var ov = document.getElementById("proton-hat-ov");
    if (!ov) { STATE.open = false; return; }
    ov.classList.remove("ph-in");
    setTimeout(function () { if (ov && ov.parentNode) ov.parentNode.removeChild(ov); }, 260);
    STATE.open = false;
  }

  function buildTiles() {
    return HATS.map(function (h) {
      var on = h.id === STATE.sel ? " ph-on" : "";
      return "<div class='ph-tile" + on + "' data-id='" + h.id + "'>" +
        "<div class='ph-imw'><span class='ph-free'>FREE</span><img src='" + h.img + "' alt='" + h.style + " " + h.color + "' loading='lazy'></div>" +
        "<div class='ph-ck'>✓</div>" +
        "<div class='ph-st'>" + h.style + "</div><div class='ph-cl'>" + h.color + "</div></div>";
    }).join("");
  }

  function openModal() {
    if (STATE.open || document.getElementById("proton-hat-ov")) return;
    injectStyle();
    STATE.open = true;
    STATE.sel = HATS[0].id;
    var ov = document.createElement("div");
    ov.className = "ph-ov";
    ov.id = "proton-hat-ov";
    ov.innerHTML =
      "<div class='ph-card' role='dialog' aria-modal='true' aria-label='Add your free hat'>" +
        "<button class='ph-x' aria-label='Close'>×</button>" +
        "<span class='ph-badge'>Free with your paddle</span>" +
        "<div class='ph-h'>Add your <b>free rope cap</b></div>" +
        "<p class='ph-sub'>Nice pick! Your paddle comes with a free Proton hat &mdash; choose your look and we'll drop it in at $0.</p>" +
        "<div class='ph-grid'>" + buildTiles() + "</div>" +
        "<button class='ph-cta'>Add my free hat &mdash; $0</button>" +
        "<button class='ph-no'>No thanks</button>" +
        "<p class='ph-note'>No code needed. Applied automatically at checkout.</p>" +
      "</div>";
    document.body.appendChild(ov);
    requestAnimationFrame(function () { ov.classList.add("ph-in"); });
    lsSet(LS_OFFERED, "1");

    ov.addEventListener("click", function (e) {
      if (e.target === ov) { dismiss(); return; }
      var x = e.target.closest && e.target.closest(".ph-x");
      if (x) { dismiss(); return; }
      var no = e.target.closest && e.target.closest(".ph-no");
      if (no) { dismiss(); return; }
      var tile = e.target.closest && e.target.closest(".ph-tile");
      if (tile) {
        STATE.sel = Number(tile.getAttribute("data-id"));
        var tiles = ov.querySelectorAll(".ph-tile");
        for (var i = 0; i < tiles.length; i++) tiles[i].classList.remove("ph-on");
        tile.classList.add("ph-on");
        return;
      }
      var cta = e.target.closest && e.target.closest(".ph-cta");
      if (cta) {
        cta.setAttribute("disabled", "disabled");
        cta.textContent = "Adding…";
        addHat(STATE.sel).then(function () {
          lsSet(LS_ADDED, "1");
          notifyThemeCartChanged();
          cta.textContent = "Added! ✓";
          setTimeout(closeModal, 650);
        });
      }
    });
  }

  function dismiss() {
    lsSet(LS_DISMISSED, "1");
    closeModal();
  }

  /* ---------------- reconcile ---------------- */
  function reconcile() {
    if (STATE.busy || inactiveContext()) return;
    STATE.busy = true;
    loadEligible().then(function (eligible) {
      return getCart().then(function (cart) {
        if (!cart) return;
        var units = paddleUnits(cart, eligible);

        // No eligible paddle -> tidy any hat WE added, reset flags for a fresh start.
        if (units < 1) {
          var mine = ourHatLines(cart);
          if (mine.length) {
            return mine.reduce(function (p, ln) { return p.then(function () { return removeLine(ln.key); }); }, Promise.resolve())
              .then(function () { lsSet(LS_OFFERED, "0"); lsSet(LS_DISMISSED, "0"); lsSet(LS_ADDED, "0"); notifyThemeCartChanged(); });
          }
          lsSet(LS_OFFERED, "0"); lsSet(LS_DISMISSED, "0"); lsSet(LS_ADDED, "0");
          if (STATE.open) closeModal();
          return;
        }

        // Hat already in cart, or shopper dismissed/was offered -> don't pop.
        if (hatInCart(cart)) { if (STATE.open) closeModal(); return; }
        if (lsGet(LS_DISMISSED) === "1") return;
        if (lsGet(LS_OFFERED) === "1") return;

        openModal();
      });
    }).catch(function (e) { log("reconcile error", e && e.message); })
      .then(function () { STATE.busy = false; });
  }

  function schedule() { if (STATE.timer) clearTimeout(STATE.timer); STATE.timer = setTimeout(reconcile, 350); }

  var CART_RE = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/i;
  function hookFetch() {
    if (!window.fetch || window.fetch.__phHooked) return;
    var orig = window.fetch;
    var wrapped = function (input) {
      var url = (typeof input === "string") ? input : (input && input.url) || "";
      var pr = orig.apply(this, arguments);
      try { if (CART_RE.test(url)) pr.then(function () { schedule(); }).catch(function () {}); } catch (e) {}
      return pr;
    };
    wrapped.__phHooked = true;
    window.fetch = wrapped;
  }
  function hookXHR() {
    try {
      var open = XMLHttpRequest.prototype.open;
      if (open.__phHooked) return;
      var wrapped = function (method, url) {
        try { if (CART_RE.test(url || "")) this.addEventListener("load", function () { schedule(); }); } catch (e) {}
        return open.apply(this, arguments);
      };
      wrapped.__phHooked = true;
      XMLHttpRequest.prototype.open = wrapped;
    } catch (e) {}
  }

  function init() {
    if (window.ProtonHat && window.ProtonHat._booted) return;
    hookFetch(); hookXHR();
    schedule();
    ["cart:updated", "cart:refresh", "cart:change"].forEach(function (ev) { document.addEventListener(ev, schedule); });
    try {
      window.ProtonHat = Object.assign(window.ProtonHat || {}, {
        _version: "2026-07-29", _booted: true, _disabled: false,
        show: openModal, reconcile: reconcile,
        disable: function () { window.ProtonHat._disabled = true; if (STATE.open) closeModal(); },
        reset: function () { lsSet(LS_OFFERED, "0"); lsSet(LS_DISMISSED, "0"); lsSet(LS_ADDED, "0"); schedule(); }
      });
    } catch (e) {}
    log("active — hats", HAT_IDS.join(","));
  }

  if (document.readyState === "loading") { document.addEventListener("DOMContentLoaded", init); } else { init(); }
})();
